<template>
    <div class="finder__control">
        <RadioPillGroup
            class="finder__pills"
            v-model="localValue"
            :options="options"
            :aria-label="ariaLabel"
        />

        <div
            class="general__dropdown finder__dropdown"
            :class="[ dropdownClass, { french: lang === 'fr' } ]"
        >
            <label class="vh" :for="selectId">{{ ariaLabel }}</label>
            <select
                :id="selectId"
                ref="selectEl"
                :aria-labelledby="labelledBy"
            >
                <option v-if="includeEmptyOption" value="">{{ ariaLabel }}</option>
                <option
                    v-for="option in options"
                    :key="option.value"
                    :value="option.value"
                >
                    {{ option.label }}
                </option>
            </select>
        </div>
    </div>
</template>

<script>
import 'select2/dist/js/select2.full.js';
import RadioPillGroup from './RadioPillGroup.vue';

export default {
    components: {
        RadioPillGroup,
    },
    props: {
        options: {
            type: Array,
            required: true,
        },
        modelValue: {
            type: [ String, Number ],
            default: null,
        },
        ariaLabel: {
            type: String,
            required: true,
        },
        labelledBy: {
            type: String,
            required: true,
        },
        selectId: {
            type: String,
            required: true,
        },
        dropdownClass: {
            type: String,
            default: '',
        },
        includeEmptyOption: {
            type: Boolean,
            default: false,
        },
    },
    emits: [ 'update:modelValue' ],
    data() {
        return {
            lang: window.php_data?.lang || '',
            select2Ready: false,
            mediaQuery: null,
        };
    },
    computed: {
        localValue: {
            get() {
                return this.modelValue;
            },
            set( value ) {
                this.$emit( 'update:modelValue', value );
            },
        },
        isMobile() {
            return this.mediaQuery?.matches ?? false;
        },
    },
    watch: {
        modelValue() {
            this.syncSelectValue();
        },
        options() {
            if ( ! this.isMobile ) {
                return;
            }

            this.$nextTick( () => {
                this.reinitSelect2();
            } );
        },
    },
    mounted() {
        this.mediaQuery = window.matchMedia( '(max-width: 767px)' );
        this.mediaQuery.addEventListener( 'change', this.handleBreakpointChange );

        this.$nextTick( () => {
            if ( this.isMobile ) {
                this.initSelect2();
            }
        } );
    },
    beforeUnmount() {
        this.mediaQuery?.removeEventListener( 'change', this.handleBreakpointChange );
        this.destroySelect2();
    },
    methods: {
        handleBreakpointChange() {
            if ( this.isMobile ) {
                this.$nextTick( () => {
                    this.initSelect2();
                } );
                return;
            }

            this.destroySelect2();
        },
        getSelectValue() {
            if ( this.modelValue === null || this.modelValue === '' ) {
                return '';
            }

            return String( this.modelValue );
        },
        parseSelectValue( value ) {
            if ( value === '' || value === null ) {
                return null;
            }

            const option = this.options.find( ( item ) => String( item.value ) === String( value ) );

            return option ? option.value : value;
        },
        syncSelectValue() {
            if ( ! this.select2Ready ) {
                return;
            }

            const $select = jQuery( this.$refs.selectEl );
            const nextValue = this.getSelectValue();

            if ( String( $select.val() ) !== nextValue ) {
                $select.val( nextValue ).trigger( 'change.select2' );
            }
        },
        initSelect2() {
            if ( this.select2Ready || ! this.$refs.selectEl ) {
                return;
            }

            const vm = this;
            const $select = jQuery( this.$refs.selectEl );

            $select.select2( {
                width: '100%',
            } ).on( 'change', function () {
                const parsedValue = vm.parseSelectValue( jQuery( this ).val() );

                if ( parsedValue !== vm.modelValue ) {
                    vm.$emit( 'update:modelValue', parsedValue );
                }
            } );

            $select.val( this.getSelectValue() ).trigger( 'change.select2' );
            this.select2Ready = true;
        },
        destroySelect2() {
            if ( ! this.select2Ready || ! this.$refs.selectEl ) {
                return;
            }

            jQuery( this.$refs.selectEl ).off( 'change' ).select2( 'destroy' );
            this.select2Ready = false;
        },
        reinitSelect2() {
            this.destroySelect2();
            this.initSelect2();
        },
    },
};
</script>
